const error = {
    OK: 200,
    BAD_REQUEST: 400,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    SERVICE_UNAVAILABLE: 503,
};

class Api {
    request(url, params = {}, method = 'GET', data = {}, headers = {}) {
        const ret = [];
        Object.keys(params).forEach(key => {
            ret.push(`${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`);
        });
        const urlParams = ret.length ? `?${ret.join('&')}` : '';
        
        return new Promise((resolve, reject = () => {}) => {
            const xhttp = new XMLHttpRequest();
            xhttp.open(method, process.env.VUE_APP_API_URL + url + urlParams, true);
            xhttp.setRequestHeader('Content-Type', 'application/json');
            Object.keys(headers).forEach(name => {
                xhttp.setRequestHeader(name, headers[name]);
            });
            xhttp.withCredentials = true;
            xhttp.responseType = 'json';
            xhttp.onload = () => {
                resolve(xhttp.response);
            };
            xhttp.onerror = e => {
                console.error('Error xhttp:');
                reject(e);
            };
            xhttp.send(JSON.stringify(data));
        });
    }
}

export {Api as ApiClass, error};
export default new Api();
